import { CommonModel } from 'models/common.model';
import { PhoneNumberType } from 'enum/phone-number-type/phone-number-type.enum';

const getPhoneNumberByType = (phoneNumbers: CommonModel.PhoneNumber[], type: PhoneNumberType) => {
	return phoneNumbers.find(phone => phone.PhoneNumberType === type);
};

export default getPhoneNumberByType;
